import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { changeHead } from '../redux/head/headActions';
import { fetchProjectDetail } from '../redux/content/contentActions';

import { MHero, MLoader } from '../components/molecules';
import pageConfig from '../config/page.config';

const mapStateToProps = state => ({
	name: get(state, 'content.projects.selected.name', ''),
	description: get(state, 'content.projects.selected.rteText', ''),
	featuredImage: get(state, 'content.projects.selected.image.url', ''),
	seoTitle: get(state, 'content.projects.selected.seoTitle', null),
	seoDescription: get(state, 'content.projects.selected.seoDescription', null),
	isFetching: get(state, 'content.isFetching', true),
});

class ProjectDetailPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			description: '',
			featuredImage: undefined,
			isFetching: true,
			seoTitle: null,
			seoDescription: null,
		};
	}

	componentDidMount() {
		this.props.fetchProjectDetail(this.props.match.params.slug);
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (key in props && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}

		// Update SEO title & description
		if (props.seoTitle || props.seoDescription) {
			const seoTitle = props.seoTitle || this.props.intl.formatMessage({ id: pageConfig.projectDetail.title });
    		const seoDescription = props.seoDescription || this.props.intl.formatMessage({ id: pageConfig.projectDetail.description });
			this.props.changeHead({
				id: pageConfig.projectDetail.id,
				title: seoTitle,
				description: seoDescription,
				showSocialMedia: true,
			});
		}
	}

	render() {
		const crumbs = this.props.match.url.split('/').filter(item => item !== '');
		let content = <MLoader className="article--loader-hero" />;

		if (!this.state.isFetching) {
			content = [
				<MHero
					key="hero"
					img={this.state.featuredImage}
					currentPage={this.state.name}
					parents={crumbs.slice(0, -1)}
					className="a-hero--bottom-align"
				/>,
				<article
					key="body"
					className="section-xx layout-body section--project-body"
				>
					<h1>{this.state.name}</h1>
					<div dangerouslySetInnerHTML={{ __html: this.state.description }} />
				</article>,
			];
		}

		return (
			<section>
				{content}
			</section>
		);
	}
}

ProjectDetailPage.propTypes = {
	fetchProjectDetail: PropTypes.func.isRequired,
	changeHead: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	fetchProjectDetail,
	changeHead,
})(injectIntl(ProjectDetailPage)));



// WEBPACK FOOTER //
// ./src/pages/project-detail.page.js